// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../DataCache';
import { Instrument } from './Instrument';
import { Route } from './Route';
export class RouteUtils {
    static findRouteForSources(instrument) {
        if (!Instrument.IsWorkingInstrument(instrument)) {
            return null;
        }
        const symbolRouteName = instrument.getRoute();
        const dc = DataCache;
        let route = dc.Routes.getRouteByName(symbolRouteName);
        if (route) {
            route = dc.Routes.getRouteById(route.QuoteRouteId);
        }
        return route;
    }
    static isSeparatedSourceMode(instrument) {
        if (!instrument) {
            return false;
        }
        const route = RouteUtils.findRouteForSources(instrument);
        return route && route.ShowMode === Route.ClientShowMode.BuyerSeller;
    }
}
